import styled from "@emotion/styled";
import { MDSText } from "@/mds";

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.spacing["1"]};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  padding: ${({ theme }) => `${theme.spacing["3"]} ${theme.spacing["4"]}`};
`;

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing["4"]};
  padding: ${({ theme }) => `${theme.spacing["3"]} 0`};
  flex-direction: row;
  flex-wrap: wrap;
`;

export const RowLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["1"]};
  min-width: 0;
  flex: 1;
  min-width: 160px;
`;

export const RowTitle = styled(MDSText)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const RowDescription = styled(MDSText)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const RowRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 140px;
`;

export const RowRightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing["1"]};
  min-width: 140px;
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.border.default};
`;

export const EnabledText = styled(MDSText)`
  color: ${({ theme }) => theme.colors.text.positive};
  text-align: center;
`;

export const DeniedText = styled(MDSText)`
  color: ${({ theme }) => theme.colors.text.danger};
`;

export const ToggleRowContainer = styled(RowContainer)<{ hasRightSlot: boolean }>`
  gap: ${({ theme }) => theme.spacing["3"]};
  justify-content: ${({ hasRightSlot }) => (hasRightSlot ? "space-between" : "flex-start")};
`;

export const ToggleRowContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["3"]};
  flex: 1;
  min-width: 0;
`;

export const ToggleRight = styled(RowRight)`
  justify-content: flex-end;
`;
